import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import './style.scss';

function Pagination({ total, limit, page, setPage, pageListArr }) {
  const numPages = Math.ceil(total / limit);

  return (
    <>
      <nav className="pageNav">
        <button className="pageButton"
          type="button"
          onClick={() => setPage(page - 1)}
          disabled={page === 1}
          aria-label='이전'
        >
          &lt;
        </button>
        {pageListArr.map((pageNum, i) => {
          return (
            <button className="pageButton"
              key={i + 1}
              onClick={() => setPage(pageNum)}
              aria-current={page === pageNum ? "page" : null}
              type="button"
            >
              {pageNum}
            </button>
          );
        })}
        <button className="pageButton"
          type="button"
          onClick={() => setPage(page + 1)}
          disabled={page === numPages}
          aria-label='다음'
        >
          &gt;
        </button>
      </nav>
    </>
  );
}

Pagination.propTypes = {
  total: PropTypes.number,
  limit: PropTypes.number,
  page: PropTypes.number,
  setPage: PropTypes.func,
  pageListArr: PropTypes.array,
};

Pagination.defaultProps = {
  total: 1000,
  limit: 16,
  page: 1,
  setPage: () => {},
  pageListArr: [],
};

export default Pagination;
